import React from "react";
import { Navigate } from "react-router-dom";

const Authmiddleware = (props) => {
  const adminKey = sessionStorage.getItem("pk_admin_key");
  const farmKey = sessionStorage.getItem("pk_farm_key");

  // If neither admin nor farm_user is logged in, redirect to login
  if (!adminKey && !farmKey) {
    return <Navigate to="/login" />;
  }

  // Otherwise, allow access
  return <>{props.children}</>;
};

export default Authmiddleware;
